var exports = {
  "k": "xfb577c5e--956ed4--container",
};

module.exports = exports;
